import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { bulkCreatePurchases } from 'Services/purchases/purchasesService'
import { AppNotification } from 'Utils/types/appNotification'
import { QueryNames } from 'Hooks/api/queryNames'
import { usePeoplePageContext } from 'Contexts/PeoplePageContext'
import { useErrorReporter } from 'Hooks/useErrorReporter'
import { RequestResponse } from 'Services/apiResponseTypes'

export const useBulkCreatePurchasesMutation = () => {
  const reportError = useErrorReporter()
  const queryClient = useQueryClient()
  const { setModal } = usePeoplePageContext()

  return useMutation<RequestResponse, Error, FormData>(
    [QueryNames.BulkCreatePurchases],
    async (formData) => {
      const response = await bulkCreatePurchases(formData)
      if (!response.success) {
        throw new Error(response.message || AppNotification.BulkCreatePurchasesFailure)
      }
      return response
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryNames.UsersForEmployer])
        toast.success(AppNotification.BulkCreatePurchasesSuccess)
        setModal(undefined)
      },
      onError: (error) => {
        reportError(`useBulkCreatePurchasesMutation error: ${error.message}`)
        toast.error(AppNotification.BulkCreatePurchasesFailure)
      }
    }
  )
}
